import type { WidgetId } from "types/dashboard";
import type { Payment } from "types/payment";
import type { RecallCampaignGroup } from "@services/api/recallCampaigns";

import StatCardsWidget from "./StatCardsWidget";
import RecentOrdresWidget from "./RecentOrdresWidget";
import PaymentsChartWidget from "./PaymentsChartWidget";
import PaymentSuccessRateWidget from "./PaymentSuccessRateWidget";
import RecallCampaignsWidget from "./RecallCampaignsWidget";
import ClientSatisfactionWidget from "./ClientSatisfactionWidget";
import RecentMessagesWidget from "./RecentMessagesWidget";
import RdvDuJourWidget from "./RdvDuJourWidget";
import DevisEnAttenteWidget from "./DevisEnAttenteWidget";
import PaiementsEnAttenteWidget from "./PaiementsEnAttenteWidget";
import OrdresBloquesWidget from "./OrdresBloquesWidget";
import OrdresUrgentsWidget from "./OrdresUrgentsWidget";
import OrdresByStatusWidget from "./OrdresByStatusWidget";
import TeamActivityWidget from "./TeamActivityWidget";


interface SharedData {
  payments: Payment[];
  campaigns: RecallCampaignGroup[];
}

export default function WidgetRenderer({ id, data }: { id: WidgetId; data: SharedData }) {
  switch (id) {
    case "stat_cards":
      return <StatCardsWidget />;
    case "recent_ordres":
      return <RecentOrdresWidget />;
    case "payments_chart":
      return <PaymentsChartWidget payments={data.payments} />;
    case "payment_success_rate":
      return <PaymentSuccessRateWidget payments={data.payments} />;
    case "recall_campaigns":
      return <RecallCampaignsWidget campaigns={data.campaigns} />;
    case "client_satisfaction":
      return <ClientSatisfactionWidget />;
    case "recent_messages":
      return <RecentMessagesWidget />;
    case "rdv_du_jour":
      return <RdvDuJourWidget />;
    case "devis_en_attente":
      return <DevisEnAttenteWidget />;
    case "paiements_en_attente":
      return <PaiementsEnAttenteWidget />;
    case "ordres_bloques":
      return <OrdresBloquesWidget />;
    case "ordres_urgents":
      return <OrdresUrgentsWidget />;
    case "ordres_by_status":
      return <OrdresByStatusWidget />;
    case "team_activity":
      return <TeamActivityWidget />;
    default:
      return null;
  }
}
